import {useCallback, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setCreateGroupPayload, selectCreateGroupPayload} from '../slices/createProjectSlice'
import {useCreateProjectDetails} from '../../AdminPanel/api/createProject'

export const useCreateProject = () => {
  const dispatch = useDispatch()
  const createGroupPayload = useSelector(selectCreateGroupPayload)

  const [creategroup, {loading: createProjectLoading, error: createProjectError}] = useCreateProjectDetails()

  const handleCreate = useCallback(
    (createPayload, handleClickOpen, createProjectDetails) => {
      const {setShowNotification, exit, setNavigateToProjectList, setInputDisabled} = createProjectDetails
      dispatch(setCreateGroupPayload(createPayload))
      if (
        createPayload.groupName.length === 0 ||
        createPayload.filters.length === 0 ||
        createPayload.jurisdiction.length === 0
      ) {
        handleClickOpen()
      } else {
        // make api call to create group
        creategroup({variables: createPayload})
        if (!createProjectLoading && !createProjectError) {
          setShowNotification(true)
          if (exit && !createProjectError) {
            setNavigateToProjectList(true)
          }
          setInputDisabled(true)
        }
      }
    },
    [dispatch, creategroup, createProjectLoading, createProjectError]
  )

  // make api call here to create group with createGroup Payload if createProject is true
  const saveCreateProjectDetails = useCallback(
    (setShowNotification) => {
      creategroup({variables: createGroupPayload})
      setShowNotification(true)
    },
    [creategroup, createGroupPayload]
  )

  const values = useMemo(
    () => ({
      saveCreateProjectDetails,
      handleCreate,
      creategroup,
      createProjectError,
      createProjectLoading,
      createGroupPayload
    }),
    [saveCreateProjectDetails, handleCreate, creategroup, createProjectError, createProjectLoading, createGroupPayload]
  )

  return values
}
